"use strict";
var lib_core = require("lib-core");
var editor_3d = require("editor-3d-light");
var THREE           = require("three");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
const { BufferGeometry } = require('three')
var ThreejsDefaults = cio_datamodel.ThreejsDefaults;


var FootprintInstanceInteractionView = function (editorView, interactionModel, cameraModel, config) {
     var self = this;
    editor_3d.AbstractSelectable3dObjectView.call(this, interactionModel, editorView);

    this.editorView = editorView;
    this.model = interactionModel;
    this.data = this.model.data;
    //this.scale = this.model.scale;
    this.scale = cio_config.UnitConversions.convert(cio_config.UnitConversions.distanceDataUnit, cio_config.UnitConversions.defaultDisplayUnit, 1);
    this.hideGrid = config.hideGrid;
    this.cameraModel = cameraModel;
    this.lineColor = this.nonSnappedLine;
    this.config = config;


    this.gridMeshes = [];
    this.nonSnappedLine = 0xaaaaaa;
    this.snappedLine = 0x5599ff;

    this.packageObject = null;
    this.footprintObject = null;
    this.boardObject = null;
    this.selectionObject = null;

    this.packageBuilding = false;
    this.packageOverwrite = false;

    // Creation of package always gets triggered by model observer now,
    // since mode handles the loading

    self.createFootprint();
    self.buildGrid();
    self.createPackage();

    self.initListeners();

    self.editorView.render();

    self.setOpacity(this.model.packageIM.packageTransparency()/100, self.packageObject);
};

lib_core.inherit(FootprintInstanceInteractionView, editor_3d.AbstractSelectable3dObjectView);

module.exports = FootprintInstanceInteractionView;

FootprintInstanceInteractionView.prototype.initListeners = function(){
    var self = this;

    this.model.footprintRenderGroup.onChange(this, function() {
         if(self.model.isAlive() && self.data.isAlive() && self.data.description() && self.data.description().isAlive()){
             self.editorView.heavyHandler.scheduleHeavy('rebuild_footprint', self.rebuildFootprint, self, [], self);
         }
    });

    this.data.model3dPosition.onChange("positionChange", function(){
        if(self.model.isAlive() && self.data.isAlive())
            self.editorView.heavyHandler.scheduleHeavy('orient_package', self.orientPackage, self, [], self);
    });

    this.data.model3dRotation.onChange("rotationChange", function(){
        if(self.model.isAlive() && self.data.isAlive())
            self.editorView.heavyHandler.scheduleHeavy('orient_package', self.orientPackage, self, [], self);
    });

    this.model.packageIM.packageThreejsRenderGroup.onChange("buildPackageView", function(val, old){
         if(self.model.isAlive() && self.data.isAlive()){
             self.createPackage();
         }
    })

    this.model.footprintOrigin.onChange(this, function(val, old){
         if(self.model.isAlive() && self.data.isAlive()){
             self.editorView.heavyHandler.scheduleHeavy('rebuild_grid', self.rebuildGrid, self, [], self);
         }
    });

    if(this.config.hoverTransparent){
        this.model.selected.onChange(this, function(val, old){
            if(self.model.isAlive() && self.data.isAlive()){
                if(val){
                    self.editorView.heavyHandler.scheduleHeavy('make_transparent', function() {
                        self.setOpacity(0.5);
                    }, self, [], self);
                } else {
                    self.editorView.heavyHandler.scheduleHeavy('make_opaque', function() {
                        self.setOpacity(1);
                    }, self, [], self);
                }
            }
        });
    }

    this.model.snapped.onChange(this, function(val){
        if(val){
            self.lineColor = self.snappedLine;
        } else {
            self.lineColor = self.nonSnappedLine;
        }
        self.rebuildGrid();
    });


    this.model.packageIM.showBoard.onChange({}, function(val){
        if(val){
            // show the board
            self.showBoard();

        } else {
            // hide board
            self.hideBoard();
        }
    });

    this.model.packageIM.showFootprint.onChange({}, function(val){
        if(val){
            // show the Footprint
            self.showFootprint();

        } else {
            // hide footprint
            self.hideFootprint();
        }
    });

    this.model.packageIM.show3dModel.onChange({}, function(val){
        if(val){
            // show the 3D model
            self.show3dModel();

        } else {
            // hide 3D model
            self.hide3dModel();
        }
    });

    this.model.packageIM.showGrid.onChange({}, function(val){
        if(val){
            // show the grid
            self.showGridMesh();

        } else {
            // hide grid
            self.hideGridMesh();

        }
    });


    if(this.config.hoverTransparent){
        this.model.handlesHovered.onChange({}, function(val){
            if(val){
                self.setOpacity(0.5);
            } else if(!self.model.hovered()){
                self.setOpacity(1);
            }
        });

        this.model.hovered.onChange({}, function(val){
            if(val){
                self.setOpacity(0.5);
            } else if(!self.model.handlesHovered()){
                self.setOpacity(1);
            }
        });
    }

    this.model.packageIM.packageTransparency.onChange({}, function(val){
        self.setOpacity(val/100, self.packageObject);
    });
}


FootprintInstanceInteractionView.prototype.setOpacity = function(val, object){

    if(!object) return;

    object.traverse((child) => {
        if (child.isMesh) {
            if (Array.isArray(child.material)) {
                child.material.forEach((material) => {
                    material.transparent = true
                    material.opacity = val
                })
            } else if (child.material) {
                child.material.transparent = true
                child.material.opacity = val
            }
        }
    })

    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.createPackage = function () {
    var self = this;
    if(!this.data.isAlive()) return;

    self.editorView.removeMeshFromSelectableList(self.selectionObject);
    self.editorView.rootGroup.remove(self.packageObject);
    self.editorView.rootGroup.remove(self.selectionObject);
    self.editorView.destroyObject(self.packageObject);
    self.editorView.destroyObject(self.selectionObject);

    if(!this.model.packageIM.packageThreejsRenderGroup()) return;

    var packageGroup = this.model.packageIM.packageThreejsRenderGroup().clone();
    var matrix = new THREE.Matrix4();
    matrix.makeScale(self.scale, self.scale, self.scale);
    packageGroup.matrix = matrix;
    self.packageObject = new THREE.Group();
    self.packageObject.matrixAutoUpdate = false;
    self.packageObject.add(packageGroup);

    self.editorView.rootGroup.add(self.packageObject);

    var selectionGroup = this.model.packageIM.boundingGeometry().clone();
    var matrix2 = new THREE.Matrix4();
    matrix2.makeScale(self.scale, self.scale, self.scale);
    selectionGroup.matrix = matrix2;
    self.selectionObject = new THREE.Group();
    self.selectionObject.matrixAutoUpdate = false;
    self.selectionObject.add(selectionGroup);

    self.editorView.addMeshToSelectableList(self.selectionObject, self.model);
    self.editorView.rootGroup.add(self.selectionObject);
    self.orientPackage();

    self.setOpacity(this.model.packageIM.packageTransparency()/100, self.packageObject);

    if(this.model.packageIM.show3dModel()) {
        this.show3dModel();
    } else {
        this.hide3dModel();
    }

    self.editorView.render();
}

FootprintInstanceInteractionView.prototype.showBoard = function () {
    this.boardObject.visible = true;
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.showGridMesh = function () {
    var lines = this.gridMeshes.length;
    var count = 0
    while(count < lines) {
        this.gridMeshes[count].visible = true;
        count+=1;
    }
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.showFootprint = function () {
    this.footprintObject.visible = true;
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.show3dModel = function () {
    if(this.packageObject != null) {
        this.packageObject.visible = true;
        this.editorView.render();
    }
}

FootprintInstanceInteractionView.prototype.hideBoard = function () {
    this.boardObject.visible = false;
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.hideGridMesh = function () {
    var lines = this.gridMeshes.length;
    var count = 0
    while(count < lines) {
        this.gridMeshes[count].visible = false;
        count+=1;
    }
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.hideFootprint = function () {
    this.footprintObject.visible = false;
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.hide3dModel = function () {
    this.packageObject.visible = false;
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.createFootprint = function () {
    if(!this.data.isAlive()) return;

    this.footprintObject = new THREE.Object3D();
    this.footprintObject.matrixAutoUpdate = false;
    var footprint = this.model.footprintRenderGroup().clone();

    var scale = (new THREE.Matrix4());
    scale.makeScale(this.scale, this.scale, this.scale);

    this.footprintObject.add(footprint);

    this.footprintObject.matrix = scale;

    this.editorView.rootGroup.add(this.footprintObject);


    this.boardObject = new THREE.Object3D();

    this.boardObject.matrixAutoUpdate = false;
    this.boardObject.matrix = scale;
    var board = this.model.boardRenderGroup().clone();

    this.boardObject.add(board);
    this.editorView.rootGroup.add(this.boardObject)

    if(this.model.packageIM.showBoard()) {
        this.showBoard();
    } else {
        this.hideBoard();
    }

    if(this.model.packageIM.showFootprint()) {
        this.showFootprint();
    } else {
        this.hideFootprint();
    }

    this.editorView.render();
};

FootprintInstanceInteractionView.prototype.orientPackage = function(){
    if(!this.packageObject || !this.selectionObject) return;
    var self = this;

    var position = new THREE.Vector3(
        this.data.model3dPosition().x * self.scale,
        this.data.model3dPosition().y * self.scale,
        this.data.model3dPosition().z * self.scale
    );
    var rotation = new THREE.Euler(
        this.data.model3dRotation().x * Math.PI/180,
        this.data.model3dRotation().y * Math.PI/180,
        this.data.model3dRotation().z * Math.PI/180
    );

    var mat = (new THREE.Matrix4());
    mat.makeRotationFromEuler( rotation );
    mat.setPosition( position );
    this.packageObject.matrix = mat;
    this.selectionObject.matrix = mat;
    self.editorView.render();
}


FootprintInstanceInteractionView.prototype.rebuildFootprint = function(){
    var self = this;
    self.editorView.rootGroup.remove(this.footprintObject);
    self.editorView.destroyObject(this.footprintObject);
    self.editorView.rootGroup.remove(this.boardObject);
    self.editorView.destroyObject(this.boardObject);
    self.createFootprint();
    self.rebuildGrid();
}


FootprintInstanceInteractionView.prototype.erase = function () {

    this.editorView.removeMeshFromSelectableList(this.selectionObject);
    this.editorView.rootGroup.remove(this.packageObject);
    this.editorView.destroyObject(this.packageObject);
    this.editorView.rootGroup.remove(this.selectionObject);
    this.editorView.destroyObject(this.selectionObject);
    this.editorView.rootGroup.remove(this.footprintObject);
    this.editorView.destroyObject(this.footprintObject);
    this.editorView.rootGroup.remove(this.boardObject);
    this.editorView.destroyObject(this.boardObject);
    this.destroyGrid();
    this.editorView.render();
};


/////////////////
//////////////



FootprintInstanceInteractionView.prototype.rebuildGrid = function(){
    if(this.hideGrid) return;
    this.destroyGrid();
    this.buildGrid();
    this.editorView.render();
}

FootprintInstanceInteractionView.prototype.destroyGrid = function(){
    for(var i = 0; i < this.gridMeshes.length; i++){
        this.editorView.rootGroup.remove(this.gridMeshes[i]);
        this.gridMeshes[i].geometry.dispose();
        this.gridMeshes[i].material.dispose();
        this.gridMeshes[i] = null;
    }
    this.gridMeshes = [];
}

FootprintInstanceInteractionView.prototype.bestCenter = function() {
    return this.data.bestCenter();
};

FootprintInstanceInteractionView.prototype.boundingBox = function() {
    return this.data.boundingBox();
};

FootprintInstanceInteractionView.prototype.padsBoundingBox = function() {
    return this.data.padsBoundingBox();
};


FootprintInstanceInteractionView.prototype.getBoardBuffer = function(){
    var info = ThreejsDefaults;
    var buffer = (info && info.boardBuffer)? info.boardBuffer : 1;
    return buffer;
}

FootprintInstanceInteractionView.prototype.buildGrid = function( ){

    function buildGeometry(vectors) {
        var vertices = new Float32Array(vectors);
        var geometry = new BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
        return geometry;
    }

    // horizontal lines
    if(this.hideGrid) return;

    if(this.model.footprintOrigin()){
        var centerX = this.bestCenter().x * this.scale;
        var centerY = this.bestCenter().y * this.scale;
    } else {
        var centerX = 0;
        var centerY = 0;
    }

    var topLeftX = (this.boundingBox().x - this.getBoardBuffer()) * this.scale;
    var topLeftY = (this.boundingBox().y - this.getBoardBuffer()) * this.scale;

    var length = (this.boundingBox().height + 2*this.getBoardBuffer()) * this.scale;
    var width = (this.boundingBox().width + 2*this.getBoardBuffer()) * this.scale;

    var thinLine = new THREE.LineBasicMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0.1,
        side: THREE.DoubleSide
    });

    var thickLine = new THREE.LineBasicMaterial({
        color: 0xffffff,
        transparent: false,
        opacity: 0.9,
        side: THREE.DoubleSide
    });


    // HORIZONTAL LINES
    var geometry = buildGeometry([
        topLeftX, centerY, 0.01,
        topLeftX + width, centerY, 0.01
    ]);
    var line = new THREE.LineSegments(geometry, thickLine);
    this.gridMeshes.push(line);
    this.editorView.rootGroup.add(line);

    // move down
    var rY =  1;
    while(rY <   topLeftY + length - centerY){
        var line = new THREE.LineSegments(geometry, thinLine);
        line.translateY(rY);
        this.gridMeshes.push(line);
        this.editorView.rootGroup.add(line);
        rY += 1;
    }

    var geometry = buildGeometry([
        topLeftX, centerY, 0.01,
        topLeftX + width, centerY, 0.01
    ]);

     // move up
    var rY =  -1;
    while(rY >  topLeftY - centerY){
        var line = new THREE.LineSegments(geometry, thinLine);
        line.translateY(rY);
        this.gridMeshes.push(line);
        this.editorView.rootGroup.add(line);
        rY -= 1;
    }

    // VERTICAL LINES
    var geometry = buildGeometry([
        centerX, topLeftY, 0.01,
        centerX, topLeftY + length, 0.01
    ]);

    var line = new THREE.LineSegments(geometry, thickLine);
    this.gridMeshes.push(line);
    this.editorView.rootGroup.add(line);

     var rX =  1;
    while(rX <  topLeftX + width - centerX){
        var line = new THREE.LineSegments(geometry, thinLine);
        line.translateX(rX);
        this.gridMeshes.push(line);
        this.editorView.rootGroup.add(line);
        rX += 1;
    }

    var geometry = buildGeometry([
        centerX, topLeftY, 0.01,
        centerX, topLeftY + length, 0.01
    ]);

     // move up
    var rX =  -1;
    while(rX >  topLeftX  - centerX){
        var line = new THREE.LineSegments(geometry, thinLine);
        line.translateX(rX);
        this.gridMeshes.push(line);
        this.editorView.rootGroup.add(line);
        rX -= 1;
    }

    if(this.model.packageIM.showGrid()) {
        this.showGridMesh();
    } else {
        this.hideGridMesh();
    }

}
